class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const thresholdShopCents = parseInt(this.dataset.thresholdShop, 10);
    const cartTotalCents = parseInt(this.dataset.cartTotal, 10);
    if (!thresholdShopCents) return;

    const currency = window.Shopify?.currency || {};
    const rate = parseFloat(currency.rate || '1');
    const code = currency.active || this.dataset.shopCurrency;

    // Buffer guards against rounding drift between our converted
    // threshold and the one Shopify actually applies at checkout.
    const buffer = rate === 1 ? 0 : 0.02;
    const threshold = Math.round(thresholdShopCents * rate * (1 + buffer));

    const remaining = Math.max(threshold - cartTotalCents, 0);
    const percent = Math.min((cartTotalCents / threshold) * 100, 100);

    const fill = this.querySelector('[data-fsb-fill]');
    const message = this.querySelector('[data-fsb-message]');
    if (!fill || !message) return;

    fill.style.width = `${percent}%`;
    this.classList.toggle('is-unlocked', remaining === 0);

    if (remaining === 0) {
      message.innerHTML = `<strong>Free shipping unlocked.</strong>`;
    } else {
      message.innerHTML =
        `<strong>${this.formatMoney(remaining, code)}</strong> away from free shipping`;
    }
  }

  formatMoney(cents, code) {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return `${code} ${amount.toFixed(2)}`;
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}